import {WixSdk} from '@wix/js-sdk-wrapper';

export const getVisitorId = () => {
  return WixSdk.Utils.getInstanceValue('uid') || WixSdk.Utils.getInstanceValue('aid');
};
